"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const regist_1 = require("../../../redux/regist");
const account_1 = require("../account");
const actionTypes_1 = require("./actionTypes");
const function_1 = require("./function");
const websocket_1 = require("./websocket");
const initialState = {
    isLoad: false,
};
regist_1.ReducerRegistry.register('base/app', (state = initialState, action) => {
    switch (action.type) {
        case actionTypes_1.APP_WILL_LOAD:
            return {
                ...state,
                isLoad: true,
            };
        case actionTypes_1.APP_WILL_UNMOUNT:
            return {
                ...state,
                isLoad: false,
            };
    }
    return state;
});
let previousAccessToken = null;
let websocket = null;
regist_1.StateListenerRegistry.register((state) => (0, account_1.getAccessToken)(state), async (access_token, store) => {
    if (!access_token)
        return;
    if (location.pathname.includes('player'))
        return;
    if (access_token !== previousAccessToken) {
        if (websocket) {
            // Close the existing WebSocket connection
            websocket.connection.close();
            websocket = null;
        }
        try {
            websocket = new websocket_1.MimacWebsocket();
            await websocket.connect(access_token);
            previousAccessToken = access_token; // Update the previous token after successful connection
        }
        catch (error) {
            alert('로그인 오류입니다. 다시 로그인하세요. ' + error);
            console.error('Error in initRefreshToken:', error);
            (0, function_1.closeWindow)();
        }
    }
}, {
    deepEquals: true,
});
